import React from 'react'
import { rewardsProps } from './rewards-interface'
import { Skeleton } from 'antd'

const Rewards = ({ img, isBigger, rewardClick, rewardDetails, loading, showVerified, name, active }: rewardsProps) => {
  return (
    loading ?
      <div>
        <Skeleton.Button active={true} size={'large'} shape={'square'} block={true}
          style={{
            height: '7rem',
            marginBottom: '0.3rem',
            borderRadius: '29px',
            marginRight: '1rem'
          }}
        />
      </div>
      :
      <div className='mr-4'>
        <div
          className={`${active ? 'border-[2px] border-appcolorpurple p-[0.3rem] rounded-[29px]' : ''}`}
        >
          <div className={`
        rounded-[29px] px-[0.5rem] bg-appcolorpurplefaintseven  relative flex justify-center
        ${isBigger ? 'py-[1.8rem] px-[1rem]' : 'py-[0.3rem] '}
        ${rewardClick ? 'cursor-pointer' : ''}
        `}
            onClick={() => {
              if (rewardDetails !== undefined && rewardClick !== undefined) {
                rewardClick(rewardDetails)
              }
            }}
          >
            <div className=''>
              <img src={img} alt="reward"
                className={`${isBigger ? 'w-14 h-14' : ''}`}
              />
            </div>
            {
              showVerified ?
                <div className={`absolute ${isBigger ? 'left-[28%] bottom-[24%]' : 'left-[0.5rem] bottom-1'}
              `}>
                  <img
                    src="/img/vectors/verified.svg" alt="verify"
                    className={`${isBigger ? 'w-5 h-5' : 'w-3 h-3'}`}
                  />
                </div> :
                null
            }
          </div>
        </div>

        {
          name !== undefined ?
            <p className={`mt-[0.3rem] font-semibold text-appcolorblack text-base capitalize text-center ${active ? '' : 'opacity-[0.6]'}`}>
              {name}
            </p> : null
        }
      </div>
  )
}

Rewards.defaultProps = {
  showVerified: false,
  active: false
}

export default Rewards